import { useState } from "react";

import { ProjectSectionEnum } from "@app_schema";

import { type IntakeType } from "./case_status_lines";

const TABS: Record<ProjectSectionEnum, IntakeType> = {
  [ProjectSectionEnum.Records]: "records",
  [ProjectSectionEnum.FinalReport]: "finalReport",
  [ProjectSectionEnum.Dictation]: "dictation",
  [ProjectSectionEnum.Supporting]: "supporting",
};

// The section a case opens on, read once per case: a teammate's upload while
// you look doesn't move the page. Records until the case has loaded.
export const useLandingSection = (
  projectId: string,
  landing: ProjectSectionEnum | undefined,
): IntakeType => {
  const [frozen, setFrozen] = useState<{
    projectId: string;
    section: IntakeType;
  }>();
  if (landing && frozen?.projectId !== projectId) {
    const next = { projectId, section: TABS[landing] };
    setFrozen(next);
    return next.section;
  }
  return frozen?.section ?? "records";
};
